(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  var section = document.querySelector('.wd-srp');
  if (!section) return;
  var wrapper = section.closest('[id^="shopify-section-"]');
  var sid = wrapper ? wrapper.id.replace('shopify-section-', '') : '';

  // Sort: preserve current query params (q, filters, type), just set sort_by
  var sortSelect = document.querySelector('[data-srp-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  }

  // Filter drawer open/close
  var drawer = document.getElementById('wd-coll-drawer-' + sid);
  var overlay = document.getElementById('wd-coll-drawer-overlay-' + sid);
  var openBtn = document.querySelector('[data-open-drawer="' + sid + '"]');
  var closeBtn = document.querySelector('[data-close-drawer="' + sid + '"]');
  var open = function () { if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  var close = function () { if (drawer) drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; };
  if (openBtn) openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close(); });

  // Color swatch active state
  if (drawer) {
    drawer.querySelectorAll('.wd-coll-filter-swatch input').forEach(function (input) {
      input.addEventListener('change', function () { input.parentElement.classList.toggle('is-active', input.checked); });
    });
  }

  // Load more — fetch next page and append results in place (matches the collection pages)
  var grid = section.querySelector('.wd-srp-grid');
  var loadMore = section.querySelector('.wd-coll-load-more');
  var progressBar = section.querySelector('.wd-coll-progress-bar');
  var progressText = section.querySelector('.wd-coll-progress-text');
  if (loadMore && grid) {
    loadMore.addEventListener('click', function (e) {
      e.preventDefault();
      var url = loadMore.getAttribute('href');
      if (!url || loadMore.dataset.loading === '1') return;
      loadMore.dataset.loading = '1';
      var originalText = loadMore.textContent;
      loadMore.textContent = 'Loading…';
      // Reserve incoming card slots synchronously (CLS fix — same as collection pages)
      var phPageSize = parseInt(loadMore.dataset.pageSize, 10) || 28;
      var phRemaining = parseInt(loadMore.dataset.remaining, 10) || phPageSize;
      var placeholders = [];
      for (var phI = 0; phI < Math.max(1, Math.min(phPageSize, phRemaining)); phI++) {
        var ph = document.createElement('div');
        ph.className = 'wd-card wd-card-skel';
        ph.setAttribute('aria-hidden', 'true');
        ph.innerHTML = '<div class="wd-card-img"></div><div class="wd-card-skel-line"></div><div class="wd-card-skel-line"></div>';
        placeholders.push(ph);
        grid.appendChild(ph);
      }
      var clearPlaceholders = function () { placeholders.forEach(function (p2) { p2.remove(); }); };
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.wd-srp-grid');
          if (newGrid) {
            var frag = document.createDocumentFragment();
            Array.prototype.forEach.call(newGrid.children, function (child) { frag.appendChild(child.cloneNode(true)); });
            var appendedCount = frag.children.length;
            grid.insertBefore(frag, placeholders[0] || null);
            clearPlaceholders();
            loadMore.dataset.remaining = String(Math.max(0, phRemaining - appendedCount));
            if (typeof window.WD_runCardColours === 'function') window.WD_runCardColours(grid);
            if (typeof window.WD_runCardSwipes === 'function') window.WD_runCardSwipes(grid);
          }
          if (!newGrid) clearPlaceholders();
          var newLoadMore = doc.querySelector('.wd-coll-load-more');
          if (newLoadMore && newLoadMore.getAttribute('href')) {
            loadMore.setAttribute('href', newLoadMore.getAttribute('href'));
            loadMore.textContent = originalText;
            delete loadMore.dataset.loading;
          } else {
            loadMore.style.display = 'none';
          }
          var newBar = doc.querySelector('.wd-coll-progress-bar');
          var newText = doc.querySelector('.wd-coll-progress-text');
          if (progressBar && newBar) progressBar.style.width = newBar.style.width;
          if (progressText && newText) progressText.textContent = newText.textContent;
        })
        .catch(function () { clearPlaceholders(); loadMore.textContent = originalText; delete loadMore.dataset.loading; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-announce-rotate]').forEach(function (track) {
    var msgs = track.querySelectorAll(':scope > span');
    if (!msgs.length) return;
    msgs[0].classList.add('is-active');
    if (msgs.length === 1) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-category-scroller"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.wd-cat-section');
  sections.forEach((section) => {
    const scroll = section.querySelector('.wd-cat-scroll');
    const prev = section.querySelector('.wd-cat-prev');
    const next = section.querySelector('.wd-cat-next');
    const bar = section.querySelector('.wd-cat-progress-bar');
    if (!scroll) return;

    const stepFor = () => {
      const card = scroll.querySelector('.wd-cat-card');
      return card ? card.offsetWidth : 400;
    };
    prev?.addEventListener('click', () => scroll.scrollBy({ left: -stepFor(), behavior: 'smooth' }));
    next?.addEventListener('click', () => scroll.scrollBy({ left: stepFor(), behavior: 'smooth' }));

    const update = () => {
      const max = scroll.scrollWidth - scroll.clientWidth;
      const pct = max > 0 ? scroll.scrollLeft / max : 0;
      const barWidth = (scroll.clientWidth / scroll.scrollWidth) * 100;
      if (bar) {
        bar.style.width = `${Math.max(barWidth, 12)}%`;
        const moveRange = 100 / (barWidth / 100) - 100;
        bar.style.transform = `translateX(${pct * moveRange}%)`;
      }
      if (prev) prev.disabled = scroll.scrollLeft <= 4;
      if (next) next.disabled = scroll.scrollLeft >= max - 4;
    };
    scroll.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.wd-coll');
  sections.forEach((section) => {
    const sectionEl = section.closest('[id^="shopify-section-"]');
    const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';

    // Sticky bar shadow
    const bar = section.querySelector('.wd-coll-bar');
    if (bar) {
      const onScroll = () => {
        if (window.scrollY > 220) bar.classList.add('is-scrolled');
        else bar.classList.remove('is-scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Drawer
    const drawer = document.getElementById('wd-coll-drawer-' + sectionId);
    const overlay = document.getElementById('wd-coll-drawer-overlay-' + sectionId);
    const openBtn = section.querySelector('[data-open-drawer="' + sectionId + '"]');
    const closeBtn = document.querySelector('[data-close-drawer="' + sectionId + '"]');

    const openDrawer = () => {
      drawer?.classList.add('is-open');
      overlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    const closeDrawer = () => {
      drawer?.classList.remove('is-open');
      overlay?.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    openBtn?.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });

    // Color swatch active states
    drawer?.querySelectorAll('.wd-coll-filter-swatch input').forEach((input) => {
      input.addEventListener('change', () => {
        input.parentElement.classList.toggle('is-active', input.checked);
      });
    });

    // Live-update Apply button's item count as filters change
    const drawerForm = drawer?.querySelector('form');
    const applyCount = drawer?.querySelector('[data-coll-apply-count]');
    if (drawerForm && applyCount) {
      const collectionPath = drawerForm.getAttribute('action') || window.location.pathname;
      let countAbort = null;
      let countTimer = 0;
      const refreshCount = () => {
        if (countAbort) countAbort.abort();
        countAbort = new AbortController();
        applyCount.textContent = ' · …';
        const params = new URLSearchParams(new FormData(drawerForm)).toString();
        const url = collectionPath + (params ? '?' + params : '');
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: countAbort.signal })
          .then((r) => r.text())
          .then((html) => {
            let n = null;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const collEl = doc.querySelector('.wd-coll[data-products-count]');
            if (collEl) n = parseInt(collEl.getAttribute('data-products-count'), 10);
            if (n === null || isNaN(n)) {
              const progEl = doc.querySelector('.wd-coll-progress-text');
              if (progEl) {
                const m = progEl.textContent.match(/of\s+(\d+)/i);
                if (m) n = parseInt(m[1], 10);
              }
            }
            if (n === null || isNaN(n)) {
              // fallback — count product cards on first page
              n = doc.querySelectorAll('.wd-coll-grid .wd-card').length;
            }
            applyCount.textContent = ' · Show ' + n + ' item' + (n === 1 ? '' : 's');
          })
          .catch((err) => {
            if (err.name !== 'AbortError') applyCount.textContent = '';
          });
      };
      drawerForm.addEventListener('change', () => {
        clearTimeout(countTimer);
        countTimer = setTimeout(refreshCount, 250);
      });
    }

    // Grid toggle
    const grid = document.getElementById('wd-coll-grid-' + sectionId);
    section.querySelectorAll('.wd-coll-grid-toggle button').forEach((btn) => {
      btn.addEventListener('click', () => {
        section.querySelectorAll('.wd-coll-grid-toggle button').forEach((b) => b.classList.remove('is-on'));
        btn.classList.add('is-on');
        grid?.classList.remove('wd-cols-2', 'wd-cols-3', 'wd-cols-4');
        grid?.classList.add('wd-cols-' + btn.dataset.cols);
      });
    });

    // Load more — fetch next page and append products in place
    const loadMore = section.querySelector('.wd-coll-load-more');
    const progressBar = section.querySelector('.wd-coll-progress-bar');
    const progressText = section.querySelector('.wd-coll-progress-text');

    if (loadMore && grid) {
      loadMore.addEventListener('click', async (e) => {
        e.preventDefault();
        const url = loadMore.getAttribute('href');
        if (!url || loadMore.dataset.loading === '1') return;
        loadMore.dataset.loading = '1';
        const originalText = loadMore.textContent;
        loadMore.textContent = 'Loading…';
        loadMore.classList.add('is-loading');

        // Reserve the incoming cards' space NOW (synchronously, within the CLS input grace
        // window) — the network append later fills these slots instead of shifting the
        // breadcrumbs/footer below. This was the source of the poor collection-page CLS.
        const phPageSize = parseInt(loadMore.dataset.pageSize, 10) || 24;
        const phRemaining = parseInt(loadMore.dataset.remaining, 10) || phPageSize;
        const placeholders = [];
        for (let phI = 0; phI < Math.max(1, Math.min(phPageSize, phRemaining)); phI++) {
          const ph = document.createElement('div');
          ph.className = 'wd-card wd-card-skel';
          ph.setAttribute('aria-hidden', 'true');
          ph.innerHTML = '<div class="wd-card-img"></div><div class="wd-card-skel-line"></div><div class="wd-card-skel-line"></div>';
          placeholders.push(ph);
          grid.appendChild(ph);
        }
        const clearPlaceholders = () => { placeholders.forEach((ph) => ph.remove()); };

        try {
          const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Network response was not ok');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          // Append new product cards from the next page's grid
          const newGrid = doc.querySelector('#wd-coll-grid-' + sectionId) || doc.querySelector('.wd-coll-grid');
          if (newGrid) {
            const fragment = document.createDocumentFragment();
            Array.from(newGrid.children).forEach((child) => {
              fragment.appendChild(child.cloneNode(true));
            });
            const newSwipes = fragment.querySelectorAll('[data-card-swipe]');
            const appendedCount = fragment.children.length;
            grid.insertBefore(fragment, placeholders[0] || null);
            clearPlaceholders();
            loadMore.dataset.remaining = String(Math.max(0, phRemaining - appendedCount));
            if (typeof window.WD_runCardColours === 'function') window.WD_runCardColours(grid);
            // Attach swipe-progress listeners to the freshly-inserted cards only
            newSwipes.forEach((track) => {
              const trackEl = track.parentElement && track.parentElement.querySelector('[data-card-progress]');
              const thumb = trackEl && trackEl.querySelector('[data-card-progress-thumb]');
              if (!thumb || !trackEl) return;
              const items = track.querySelectorAll('.wd-card-swipe-item');
              if (items.length <= 1) return;
              let rafId = 0;
              const apply = () => {
                rafId = 0;
                const maxScroll = track.scrollWidth - track.clientWidth;
                const pct = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
                const maxTx = trackEl.clientWidth - thumb.clientWidth;
                thumb.style.transform = 'translate3d(' + (pct * maxTx) + 'px, 0, 0)';
              };
              track.addEventListener('scroll', () => {
                if (rafId) return;
                rafId = requestAnimationFrame(apply);
              }, { passive: true });
              apply();
            });
          }

          if (!newGrid) clearPlaceholders();

          // Update load more button — point to NEXT next page, or hide when no more
          const newLoadMore = doc.querySelector('.wd-coll-load-more');
          if (newLoadMore && newLoadMore.getAttribute('href')) {
            loadMore.setAttribute('href', newLoadMore.getAttribute('href'));
            loadMore.textContent = originalText;
            loadMore.classList.remove('is-loading');
            delete loadMore.dataset.loading;
          } else {
            loadMore.style.display = 'none';
          }

          // Update progress bar + text
          const newBar = doc.querySelector('.wd-coll-progress-bar');
          const newText = doc.querySelector('.wd-coll-progress-text');
          if (progressBar && newBar) progressBar.style.width = newBar.style.width;
          if (progressText && newText) progressText.textContent = newText.textContent;
        } catch (err) {
          console.error('[wd-collection] Load more failed:', err);
          clearPlaceholders();
          loadMore.textContent = originalText;
          loadMore.classList.remove('is-loading');
          delete loadMore.dataset.loading;
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    if (slides.length <= 1) return;
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var i = 0, timer = null;
    var interval = parseInt(hero.getAttribute('data-autoplay'), 10);

    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (interval > 0) timer = setInterval(function () { go(i + 1); }, interval * 1000);
    }

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { go(idx); restart(); });
    });

    // Block native image/link dragging so our own drag works
    hero.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Touch swipe (mobile)
    var tx0 = null;
    hero.addEventListener('touchstart', function (e) { tx0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (tx0 === null) return;
      var dx = e.changedTouches[0].clientX - tx0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      tx0 = null;
    }, { passive: true });

    // Mouse drag (desktop) — tracked on window so it keeps working if the cursor leaves the hero
    var mx0 = null, dragged = false;
    hero.addEventListener('mousedown', function (e) { mx0 = e.clientX; dragged = false; e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (mx0 !== null && Math.abs(e.clientX - mx0) > 6) dragged = true; });
    window.addEventListener('mouseup', function (e) {
      if (mx0 === null) return;
      var dx = e.clientX - mx0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      mx0 = null;
    });
    // If the mouse was dragged, swallow the click so the whole-image link/button doesn't fire
    hero.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);

    hero.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);

    restart();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.wd-prod-section');
  sections.forEach((section) => {
    const scroll = section.querySelector('.wd-prod-scroll');
    const prev = section.querySelector('.wd-prod-prev');
    const next = section.querySelector('.wd-prod-next');
    if (!scroll || !prev || !next) return;

    const stepFor = () => {
      const card = scroll.querySelector('.wd-card');
      return card ? card.offsetWidth + 14 : 320;
    };
    prev.addEventListener('click', () => scroll.scrollBy({ left: -stepFor() * 2, behavior: 'smooth' }));
    next.addEventListener('click', () => scroll.scrollBy({ left: stepFor() * 2, behavior: 'smooth' }));

    const update = () => {
      const max = scroll.scrollWidth - scroll.clientWidth;
      prev.disabled = scroll.scrollLeft <= 4;
      next.disabled = scroll.scrollLeft >= max - 4;
    };
    scroll.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-complete"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.wd-cset').forEach((section) => {
    const sheet = section.querySelector('[data-cset-sheet]');
    const variantsScript = section.querySelector('[data-cset-variants]');
    if (!sheet || !variantsScript) return;

    // Portal the sheet to body so transformed ancestors can't break position: fixed
    if (sheet.parentElement !== document.body) document.body.appendChild(sheet);

    const sheetSizes = sheet.querySelector('[data-cset-sheet-sizes]');
    const sheetTitle = sheet.querySelector('[data-cset-sheet-title]');
    if (!sheetSizes) return;

    let variantData = {};
    try { variantData = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const openSheet = (handle) => {
      const variants = variantData[handle];
      if (!variants || !variants.length) return;
      const itemEl = section.querySelector('[data-cset-item][data-product-handle="' + handle + '"]');
      const productName = itemEl ? itemEl.querySelector('.wd-cset-item-name')?.textContent.trim() : '';

      if (sheetTitle) {
        const name = (productName || '').trim();
        if (name) {
          const words = name.split(/\s+/);
          const first = words[0];
          const rest = words.slice(1).join(' ');
          const esc = (s) => s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
          let html = '<span class="wd-cset-sheet-title-first">' + esc(first) + '</span>';
          if (rest) html += '<span class="wd-cset-sheet-title-rest">' + esc(rest) + '</span>';
          sheetTitle.innerHTML = html;
        } else {
          sheetTitle.textContent = 'Choose your size';
        }
      }

      // Group variants by size option only (ignore color etc. — pick first available combination)
      // Render every variant as a row; show variant.title which Shopify formats as "M / Black" etc.
      let html = '';
      variants.forEach((v) => {
        const disabled = !v.available;
        html += '<button type="button" class="wd-cset-sheet-size" data-variant-id="' + v.id + '"' + (disabled ? ' disabled' : '') + '>'
          + '<span class="wd-cset-sheet-size-label">' + v.title + '</span>'
          + '<span class="wd-cset-sheet-size-cta">' + (disabled ? 'Out of stock' : 'Add to bag →') + '</span>'
          + '</button>';
      });
      sheetSizes.innerHTML = html;
      sheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wd-cset-sheet-open');
    };
    const closeSheet = () => {
      sheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wd-cset-sheet-open');
    };

    // Open sheet on +
    section.querySelectorAll('[data-cset-add]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openSheet(btn.dataset.productHandle);
      });
    });

    // Sheet clicks — size tap, close, or backdrop
    sheet.addEventListener('click', (e) => {
      if (e.target.closest('[data-cset-sheet-close]')) { closeSheet(); return; }
      const sizeBtn = e.target.closest('[data-cset-sheet-size], .wd-cset-sheet-size');
      if (!sizeBtn || sizeBtn.disabled) return;
      const variantId = sizeBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      // Submit a hidden form so the cart drawer's submit listener catches it
      const form = document.createElement('form');
      form.action = '/cart/add';
      form.method = 'post';
      form.style.display = 'none';
      const idInput = document.createElement('input');
      idInput.name = 'id'; idInput.value = variantId; form.appendChild(idInput);
      const qInput = document.createElement('input');
      qInput.name = 'quantity'; qInput.value = '1'; form.appendChild(qInput);
      const addBtn = document.createElement('button');
      addBtn.name = 'add'; addBtn.type = 'submit'; form.appendChild(addBtn);
      document.body.appendChild(form);
      closeSheet();
      form.requestSubmit ? form.requestSubmit() : form.submit();
      setTimeout(() => form.remove(), 1000);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheet.getAttribute('aria-hidden') === 'false') closeSheet();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Global zoom close handler — works regardless of section scoping
  document.addEventListener('click', (e) => {
    if (e.target.closest('.wd-pdp-zoom-close')) {
      e.preventDefault();
      if (typeof window.WD_closeZoom === 'function') window.WD_closeZoom();
      else document.body.classList.remove('wd-pdp-zoomed', 'wd-pdp-zoomed-2');
    }
  });

  const sections = document.querySelectorAll('[data-pdp]');
  sections.forEach((section) => {
    const dataEl = section.querySelector('[data-pdp-product-json]');
    if (!dataEl) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const form = section.querySelector('.wd-pdp-form');
    const variantInput = section.querySelector('[data-pdp-variant-input]');
    const priceEl = section.querySelector('[data-pdp-price]');
    const isPreorder = section.hasAttribute('data-pdp-preorder');
    const addLabel = isPreorder ? 'Preorder' : 'Add to Cart';
    const addLabelLower = isPreorder ? 'Preorder' : 'Add to cart';
    const addLabelBag = isPreorder ? 'Preorder ' : 'Add to bag ';
    const addBtn = section.querySelector('[data-pdp-add]');
    const stickyAdd = section.querySelector('[data-pdp-sticky-add]');
    const optionInputs = section.querySelectorAll('[data-pdp-option-input]');

    // Preview-only products: both CTAs open the Klaviyo sign-up form instead of adding to cart.
    section.querySelectorAll('[data-pdp-preview-signup]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const formId = btn.getAttribute('data-preview-form');
        if (!formId) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    });

    const formatMoney = (cents) => {
      const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      const locale = (window.Shopify && window.Shopify.locale) || 'en-GB';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format((cents || 0) / 100);
      } catch (e) {
        return '£' + ((cents || 0) / 100).toFixed(2);
      }
    };

    const findVariant = () => {
      const selected = [];
      section.querySelectorAll('[data-option-position]').forEach((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    };

    const updateOptionAvailability = () => {
      const optionGroups = section.querySelectorAll('[data-option-position]');
      optionGroups.forEach((group) => {
        const position = parseInt(group.dataset.optionPosition, 10);
        const otherSelected = [];
        section.querySelectorAll('[data-option-position]').forEach((g) => {
          if (g === group) return;
          const checked = g.querySelector('input:checked');
          otherSelected.push({ position: parseInt(g.dataset.optionPosition, 10), value: checked ? checked.value : null });
        });

        group.querySelectorAll('input').forEach((input) => {
          const candidate = variants.find((v) => {
            if (v.options[position - 1] !== input.value) return false;
            return otherSelected.every((sel) => sel.value === null || v.options[sel.position - 1] === sel.value);
          });
          const unavailable = !candidate || !candidate.available;
          // Size chips: keep clickable, just mark visually unavailable. Swatches stay disabled.
          if (input.classList.contains('wd-pdp-size-input')) {
            input.disabled = false;
            if (unavailable) input.setAttribute('data-unavailable', '');
            else input.removeAttribute('data-unavailable');
          } else {
            input.disabled = unavailable;
          }
        });
      });
    };

    const updateUI = () => {
      const variant = findVariant();
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          const txt = addBtn.querySelector('[data-pdp-add-text]');
          if (txt) txt.textContent = 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="wd-pdp-price--sale">' + formatMoney(variant.price) + '</span> <s class="wd-pdp-price--was">' + formatMoney(variant.compare_at_price) + '</s>';
        } else {
          priceEl.innerHTML = '<span class="wd-pdp-price-current">' + formatMoney(variant.price) + '</span>';
        }
      }

      const klarnaAmt = section.querySelector('[data-pdp-klarna-amt]');
      if (klarnaAmt) klarnaAmt.textContent = formatMoney(Math.floor(variant.price / 3));

      if (addBtn) {
        const txt = addBtn.querySelector('[data-pdp-add-text]');
        if (variant.available) {
          addBtn.disabled = false;
          if (txt) txt.textContent = addLabel;
        } else {
          addBtn.disabled = true;
          if (txt) txt.textContent = 'Sold Out';
        }
      }
      if (stickyAdd) {
        const slabel = stickyAdd.querySelector('[data-pdp-sticky-label]');
        const sprice = stickyAdd.querySelector('[data-pdp-sticky-price]');
        if (variant.available) {
          if (slabel) slabel.textContent = addLabelLower;
          if (sprice) {
            let html = formatMoney(variant.price);
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              html += ' <s class="wd-pdp-sticky-price--was">' + formatMoney(variant.compare_at_price) + '</s>';
            }
            sprice.innerHTML = html;
            sprice.style.display = '';
          }
        } else {
          if (slabel) slabel.textContent = 'Sold Out';
          if (sprice) sprice.style.display = 'none';
        }
        stickyAdd.disabled = !variant.available;
      }

      section.querySelectorAll('[data-option-position]').forEach((group, idx) => {
        const display = group.querySelector('[data-pdp-option-value]');
        if (display) display.textContent = variant.options[idx] || '';
      });

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', newUrl);

      updateOptionAvailability();
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateUI));

    const sheet = section.querySelector('[data-pdp-sheet]');
    const sheetSizeBtns = sheet ? sheet.querySelectorAll('.wd-pdp-sheet-size') : [];

    const openSheet = () => {
      if (!sheet) return;
      syncSheetFromForm();
      sheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wd-pdp-sheet-open');
    };
    const closeSheet = () => {
      if (!sheet) return;
      sheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wd-pdp-sheet-open');
    };

    const syncSheetFromForm = () => {
      if (!sheet) return;
      const position = parseInt(sheetSizeBtns[0]?.dataset.optionPosition || '0', 10);
      const group = section.querySelector('[data-option-position="' + position + '"]');
      const groupInputs = group ? Array.from(group.querySelectorAll('input')) : [];
      sheetSizeBtns.forEach((btn) => {
        const v = btn.dataset.optionValue;
        const matchedInput = groupInputs.find((i) => i.value === v);
        const unavailable = matchedInput && (matchedInput.disabled || matchedInput.hasAttribute('data-unavailable'));
        btn.disabled = !!unavailable;
        const ctaEl = btn.querySelector('.wd-pdp-sheet-size-cta');
        if (ctaEl && ctaEl.firstChild) ctaEl.firstChild.textContent = btn.disabled ? 'Out of stock ' : addLabelBag;
      });
    };

    sheetSizeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const position = parseInt(btn.dataset.optionPosition, 10);
        const value = btn.dataset.optionValue;
        const group = section.querySelector('[data-option-position="' + position + '"]');
        const targetInput = group ? Array.from(group.querySelectorAll('input')).find((i) => i.value === value) : null;
        if (targetInput && !targetInput.disabled) {
          targetInput.checked = true;
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeSheet();
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });

    if (sheet) {
      sheet.addEventListener('click', (e) => {
        if (e.target.closest('[data-pdp-sheet-close]')) closeSheet();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sheet.getAttribute('aria-hidden') === 'false') closeSheet();
      });
    }

    const guide = section.querySelector('[data-pdp-guide]');
    if (guide) {
      if (guide.parentElement !== document.body) document.body.appendChild(guide);
      const openGuide = () => {
        guide.setAttribute('aria-hidden', 'false');
        document.body.classList.add('wd-pdp-sheet-open');
      };
      const closeGuide = () => {
        guide.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('wd-pdp-sheet-open');
      };
      section.querySelectorAll('[data-pdp-size-guide-open]').forEach((b) => {
        b.addEventListener('click', openGuide);
      });
      guide.addEventListener('click', (e) => {
        if (e.target.closest('[data-pdp-guide-close]')) { closeGuide(); return; }
        const unitBtn = e.target.closest('[data-pdp-guide-unit]');
        if (unitBtn) {
          const unit = unitBtn.getAttribute('data-pdp-guide-unit');
          guide.querySelectorAll('[data-pdp-guide-unit]').forEach((b) => {
            const on = b === unitBtn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          const table = guide.querySelector('.wd-sizetable');
          if (table) table.classList.toggle('is-inch', unit === 'in');
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && guide.getAttribute('aria-hidden') === 'false') closeGuide();
      });
    }

    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', () => {
        if (sheet) {
          openSheet();
        } else {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    }

    // Tap-to-zoom (Jacquemus-style). Distinguishes tap from horizontal scroll on the carousel.
    const stackEl = section.querySelector('.wd-pdp-stack');
    const stackItems = section.querySelectorAll('.wd-pdp-stack-item');
    const stackWrap = section.querySelector('.wd-pdp-stack-wrap');

    const zoomBar = section.querySelector('.wd-pdp-zoom-bar');
    if (zoomBar && zoomBar.parentElement !== document.body) document.body.appendChild(zoomBar);

    if (stackEl && stackWrap && window.matchMedia('(max-width: 1100px)').matches) {
      const TAP_MOVE_MAX = 10;   // px — anything beyond this is a drag/scroll
      const TAP_TIME_MAX = 350;  // ms
      const ZOOM_SCALE = 1.8;

      const root = document.documentElement;
      const isZoomed = () => document.body.classList.contains('wd-pdp-zoomed');
      const isZoomed2 = () => document.body.classList.contains('wd-pdp-zoomed-2');
      const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

      let lockedScrollY = 0;
      const lockBody = () => {
        lockedScrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + lockedScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      };
      const unlockBody = () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, lockedScrollY);
      };

      const openZoom = () => {
        root.style.setProperty('--wd-zoom-scale', '1');
        root.style.setProperty('--wd-zoom-x', '0px');
        root.style.setProperty('--wd-zoom-y', '0px');
        lockBody();
        document.body.classList.add('wd-pdp-zoomed');
        // Zoom shows images scaled 2-3x — widen `sizes` so the browser upgrades to the
        // 2000/2400px srcset candidates (it never downgrades already-loaded files).
        section.querySelectorAll('.wd-pdp-stack-item img').forEach((im) => {
          if (im.getAttribute('sizes') !== '220vw') { im.setAttribute('sizes', '220vw'); im.loading = 'eager'; }
        });
      };
      const enterStage2 = () => {
        root.style.setProperty('--wd-zoom-scale', String(ZOOM_SCALE));
        document.body.classList.add('wd-pdp-zoomed-2');
      };
      const exitStage2 = () => {
        document.body.classList.remove('wd-pdp-zoomed-2', 'wd-pdp-zoom-panning');
        root.style.setProperty('--wd-zoom-scale', '1');
        root.style.setProperty('--wd-zoom-x', '0px');
        root.style.setProperty('--wd-zoom-y', '0px');
      };
      const closeAll = () => {
        if (!isZoomed()) return;
        document.body.classList.remove('wd-pdp-zoomed', 'wd-pdp-zoomed-2', 'wd-pdp-zoom-panning');
        root.style.setProperty('--wd-zoom-scale', '1');
        root.style.setProperty('--wd-zoom-x', '0px');
        root.style.setProperty('--wd-zoom-y', '0px');
        unlockBody();
      };
      window.WD_closeZoom = closeAll;

      stackItems.forEach((item) => {
        let startX = 0, startY = 0, startT = 0, maxDist = 0, tracking = false;
        let panBaseX = 0, panBaseY = 0;

        item.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          // Taps on the Play Video label belong to the video overlay, never the zoom
          if (e.target.closest('[data-pdp-vidview-open]')) return;
          tracking = true;
          startX = e.clientX; startY = e.clientY; startT = Date.now(); maxDist = 0;
          if (isZoomed2()) {
            panBaseX = parseFloat(root.style.getPropertyValue('--wd-zoom-x')) || 0;
            panBaseY = parseFloat(root.style.getPropertyValue('--wd-zoom-y')) || 0;
            try { item.setPointerCapture(e.pointerId); } catch (_) {}
          }
        });

        item.addEventListener('pointermove', (e) => {
          if (!tracking) return;
          const dx = e.clientX - startX, dy = e.clientY - startY;
          const d = Math.hypot(dx, dy);
          if (d > maxDist) maxDist = d;
          if (isZoomed2() && d > 4) {
            document.body.classList.add('wd-pdp-zoom-panning');
            const halfX = (window.innerWidth * (ZOOM_SCALE - 1)) / 2;
            const halfY = (window.innerHeight * (ZOOM_SCALE - 1)) / 2;
            const nx = clamp(panBaseX + dx, -halfX, halfX);
            const ny = clamp(panBaseY + dy, -halfY, halfY);
            root.style.setProperty('--wd-zoom-x', nx + 'px');
            root.style.setProperty('--wd-zoom-y', ny + 'px');
            e.preventDefault();
          }
        });

        const finish = () => {
          if (!tracking) return;
          tracking = false;
          document.body.classList.remove('wd-pdp-zoom-panning');
          const dt = Date.now() - startT;
          const isTap = maxDist <= TAP_MOVE_MAX && dt <= TAP_TIME_MAX;
          if (!isTap) return;
          if (!isZoomed()) openZoom();
          else if (!isZoomed2()) enterStage2();
          else exitStage2();
        };
        item.addEventListener('pointerup', finish);
        item.addEventListener('pointercancel', () => { tracking = false; document.body.classList.remove('wd-pdp-zoom-panning'); });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isZoomed()) closeAll();
      });
    }

    // Publish sticky height + wrap offset as CSS vars. Combined with `dvh` in the
    // CSS, the gallery's bottom (progress bar) always meets the sticky bar's top —
    // even when the wrap is pulled up under the transparent header (negative margin).
    const stickyBar = section.querySelector('.wd-pdp-sticky-bar');
    const wrapEl = section.querySelector('.wd-pdp-wrap, [data-pdp]') || section;
    const publishGalleryVars = () => {
      if (stickyBar) {
        const sh = stickyBar.offsetHeight;
        if (sh > 0) document.documentElement.style.setProperty('--wd-sticky-h', sh + 'px');
      }
      if (wrapEl) {
        const wt = wrapEl.getBoundingClientRect().top + window.scrollY;
        document.documentElement.style.setProperty('--wd-wrap-offset', wt + 'px');
      }
    };
    publishGalleryVars();
    window.addEventListener('load', publishGalleryVars);
    window.addEventListener('orientationchange', () => setTimeout(publishGalleryVars, 100));

    // Hide sticky ATC when user reaches the footer
    if (stickyBar && 'IntersectionObserver' in window) {
      const footer = document.querySelector('.wd-footer, footer');
      if (footer) {
        const footerObs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            stickyBar.classList.toggle('is-hidden', entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -20px 0px' });
        footerObs.observe(footer);
      }
    }

    // (Colour picker now runs INLINE next to its markup — see the <script> after .wd-pdp-colors —
    // so cached renders paint before first frame instead of waiting for this deferred bundle.)

    // Gallery progress line (mobile) — rAF-batched, GPU-friendly, no easing
    const progressEl = section.querySelector('[data-pdp-progress]');
    const progressThumb = section.querySelector('[data-pdp-progress-thumb]');
    if (progressEl && progressThumb && stackEl && stackItems.length > 1) {
      let rafId = 0;
      const apply = () => {
        rafId = 0;
        const maxScroll = stackEl.scrollWidth - stackEl.clientWidth;
        const pct = maxScroll > 0 ? stackEl.scrollLeft / maxScroll : 0;
        const maxTx = progressEl.clientWidth - progressThumb.clientWidth;
        progressThumb.style.transform = 'translate3d(' + (pct * maxTx) + 'px, 0, 0)';
        // Stay ahead of the swipe: promote the next two lazy images to eager so they're
        // already downloaded by the time they're swiped into view.
        const idx = Math.round(stackEl.scrollLeft / (stackEl.clientWidth || 1));
        // Hide the pinned Play Video label while the VIDEO slide itself is in view
        const playTag = section.querySelector('.wd-pdp-play-tag');
        if (playTag) playTag.classList.toggle('is-off', !!(stackItems[idx] && stackItems[idx].querySelector('video')));
        for (let i = idx; i <= idx + 2 && i < stackItems.length; i++) {
          const im = stackItems[i] && stackItems[i].querySelector('img[loading="lazy"]');
          if (im) im.loading = 'eager';
        }
      };
      stackEl.addEventListener('scroll', () => {
        if (rafId) return;
        rafId = requestAnimationFrame(apply);
      }, { passive: true });
      apply();
    }

    // "N Photos" signpost — appears ONLY when the shopper scrolls the info column past the
    // threshold while the image pane is still untouched (i.e. they're about to miss the gallery).
    // Scrolling the images at any point dismisses it for good.
    const moreHint = section.querySelector('[data-pdp-more]');
    const paneEl = section.querySelector('.wd-pdp-stack-wrap');
    const infoEl = section.querySelector('.wd-pdp-info');
    if (moreHint && paneEl && infoEl && window.matchMedia('(min-width: 1101px)').matches) {
      const showIfMissed = () => {
        // Triggered by scrolling the info column OR the page itself while the gallery is untouched
        if (infoEl.scrollTop > 120 || window.scrollY > 100) {
          moreHint.classList.add('is-on');
          infoEl.removeEventListener('scroll', showIfMissed);
          window.removeEventListener('scroll', showIfMissed);
        }
      };
      const dismissMore = () => {
        moreHint.classList.remove('is-on');
        moreHint.classList.add('is-done');
        paneEl.removeEventListener('scroll', dismissMore);
        infoEl.removeEventListener('scroll', showIfMissed);
        window.removeEventListener('scroll', showIfMissed);
      };
      paneEl.addEventListener('scroll', dismissMore, { passive: true });
      infoEl.addEventListener('scroll', showIfMissed, { passive: true });
      window.addEventListener('scroll', showIfMissed, { passive: true });
    }

    // Desktop: warm the below-fold gallery images once the browser is idle, so scrolling
    // the pane never shows a grey flash. Mobile keeps true lazy (swipe-ahead handles it).
    if (window.matchMedia('(min-width: 1101px)').matches) {
      const warmGallery = () => {
        section.querySelectorAll('.wd-pdp-stack-item img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(warmGallery, { timeout: 3000 });
      else setTimeout(warmGallery, 1500);
    }

    // Mobile Play Video overlay
    const vidview = section.querySelector('[data-pdp-vidview]');
    if (vidview) {
      if (vidview.parentElement !== document.body) document.body.appendChild(vidview);
      const vvVideo = vidview.querySelector('video');
      if (vvVideo) vvVideo.preload = 'none'; // only loads when the overlay is opened
      const vvOpen = () => {
        vidview.setAttribute('aria-hidden', 'false');
        document.body.classList.add('wd-pdp-vidview-open');
        if (vvVideo) {
          vvVideo.muted = true;
          vvVideo.loop = true;
          vvVideo.controls = false;
          vvVideo.setAttribute('playsinline', '');
          const vp = vvVideo.play();
          if (vp && vp.catch) vp.catch(() => {});
        }
      };
      const vvClose = () => {
        vidview.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('wd-pdp-vidview-open');
        if (vvVideo) vvVideo.pause();
      };
      section.querySelectorAll('[data-pdp-vidview-open]').forEach((b) => {
        b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); vvOpen(); });
      });
      vidview.querySelectorAll('[data-pdp-vidview-close]').forEach((b) => b.addEventListener('click', vvClose));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && vidview.getAttribute('aria-hidden') === 'false') vvClose();
      });
    }

    // Gallery videos: muted inline autoplay + loop (iOS needs BOTH the muted property and the
    // playsinline attribute). Play is driven by VISIBILITY, not a one-shot call at load —
    // Safari suspends autoplay for offscreen videos (ours is the last slide, always offscreen
    // at load), so we play when the video scrolls into view and pause it when it leaves
    // (which also stops it burning battery in the background).
    section.querySelectorAll('.wd-pdp-stack-item video').forEach((v) => {
      v.muted = true;
      v.loop = true;
      v.controls = false;
      v.setAttribute('playsinline', '');
      v.setAttribute('muted', '');
      const tryPlay = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) tryPlay(); else v.pause(); });
        }, { threshold: 0.2 }).observe(v);
      } else {
        tryPlay();
      }
    });

    updateOptionAvailability();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(root) {
    var section = root.querySelector('[data-ptabs]');
    if (!section) return;
    var tabs = section.querySelectorAll('[data-ptab]');
    var panels = section.querySelectorAll('[data-ppanel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var k = tab.getAttribute('data-ptab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-ptab') === k); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ppanel') === k); });
      });
    });
  }

  function initRecent(root) {
    var track = root.querySelector('[data-recent-track]');
    var tabBtn = root.querySelector('[data-recent-tab]');
    if (!track) return;
    var current = root.getAttribute('data-current-handle');
    var list = [];
    try { list = JSON.parse(localStorage.getItem('wd:recently-viewed') || '[]'); } catch (e) {}
    list = list.filter(function (p) { return p && p.handle && p.handle !== current; }).slice(0, 8);
    if (!list.length) return;
    var esc = function (s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; };
    // Build with the SAME markup/classes as wd-product-card so recently-viewed matches every other card.
    track.innerHTML = list.map(function (p) {
      var title = (p.title || '').trim();
      // NOOD vendor: line 1 = everything before the first pipe, line 2 = the rest (first pipe hidden). Everyone else: first word / rest.
      var isNood = String(p.vendor || '').trim().toUpperCase() === 'NOOD' && title.indexOf(' | ') > -1;
      var first, rest;
      if (isNood) {
        var pipeParts = title.split(' | ');
        first = esc(pipeParts[0]);
        rest = esc(pipeParts.slice(1).join(' | '));
      } else {
        var words = title.split(/\s+/);
        first = esc(words[0] || '');
        rest = esc(words.slice(1).join(' '));
      }
      return '<a class="wd-card" href="' + esc(p.url) + '">' +
        '<div class="wd-card-img">' + (p.image ? '<img class="wd-card-img-main" src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="wd-card-meta">' +
          '<span class="wd-card-name"><span class="wd-card-name-first">' + first + '</span>' +
          (rest ? '<span class="wd-card-name-rest">' + rest + '</span>' : '') + '</span>' +
          '<span class="wd-card-price"><span>' + esc(p.priceLabel) + '</span></span>' +
        '</div>' +
        '</a>';
    }).join('');
    if (tabBtn) tabBtn.removeAttribute('hidden');
  }

  function initAll(root) {
    initTabs(root);
    initRecent(root);
    if (typeof window.WD_runCardColours === 'function') window.WD_runCardColours(root);
    if (typeof window.WD_runCardSwipes === 'function') window.WD_runCardSwipes(root);
    // Hide the whole block if neither tab has content
    var visibleTab = root.querySelector('[data-ptab]:not([hidden])');
    root.style.display = visibleTab ? '' : 'none';
  }

  if (!customElements.get('wd-recommendations')) {
    customElements.define('wd-recommendations', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var url = this.dataset.url;
        if (this.querySelector('[data-ptabs]')) { initAll(this); }
        if (!url) return;
        var fetchRecs = function () {
          fetch(url).then(function (r) { return r.text(); }).then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('wd-recommendations');
            if (fresh && fresh.innerHTML.trim().length > 0) {
              self.innerHTML = fresh.innerHTML;
              initAll(self);
            }
          }).catch(function (err) { console.warn('[wd-recommendations] fetch failed', err); });
        };
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.unobserve(self);
          fetchRecs();
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  const looks = document.querySelectorAll('.wd-look');
  looks.forEach((look) => {
    const pieces = look.querySelectorAll('.wd-look-piece');
    const meta = look.querySelector('.wd-look-meta');
    const nameEl = look.querySelector('.wd-look-name');
    const subEl = look.querySelector('.wd-look-subtitle');
    if (!pieces.length || !nameEl || !subEl) return;

    const defaultName = nameEl.dataset.default || nameEl.textContent;
    const defaultSub = subEl.dataset.default || subEl.textContent;
    const defaultUrl = (meta && meta.dataset.defaultUrl) || (meta && meta.getAttribute('href')) || '#';

    let stickyPiece = null;

    const apply = (name, sub, url) => {
      nameEl.textContent = name;
      subEl.textContent = sub;
      if (meta) meta.setAttribute('href', url);
    };
    const reset = () => apply(defaultName, defaultSub, defaultUrl);

    pieces.forEach((piece) => {
      piece.addEventListener('mouseenter', () => {
        apply(piece.dataset.name, piece.dataset.price, piece.dataset.url);
      });
      piece.addEventListener('mouseleave', () => {
        if (stickyPiece) {
          apply(stickyPiece.dataset.name, stickyPiece.dataset.price, stickyPiece.dataset.url);
        } else {
          reset();
        }
      });
      piece.addEventListener('click', (e) => {
        e.preventDefault();
        if (stickyPiece === piece) {
          stickyPiece = null;
          piece.classList.remove('is-active');
          reset();
        } else {
          if (stickyPiece) stickyPiece.classList.remove('is-active');
          stickyPiece = piece;
          piece.classList.add('is-active');
          apply(piece.dataset.name, piece.dataset.price, piece.dataset.url);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-tabbed-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === idx);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
